"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectOrder = exports.selectOnlyOrder = exports.orderSlice = exports.fetchUpdateOrder = exports.fetchUpdateCoupon = exports.fetchGetOrder = exports.fetchCreateOrder = exports.default = exports.clearOrder = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _Input = require("../components/Input");
var _api = require("../api");
const initialState = {
  order: {
    billingAddress: '',
    country: '',
    couponId: '',
    currency: 'EUR',
    customer: {
      locale: '',
      email: ''
    },
    customerId: 0,
    discount: {
      applied: false,
      type: '',
      periods: 0
    },
    expirationDate: 0,
    id: 0,
    offer: {
      title: '',
      description: '',
      price: 0,
      currency: ''
    },
    offerId: '',
    paymentMethodId: 0,
    priceBreakdown: {
      customerServiceFee: 0,
      discountAmount: 0,
      discountedPrice: 0,
      offerPrice: 0,
      paymentMethodFee: 0,
      taxValue: 0
    },
    publisherId: 0,
    requiredPaymentDetails: false,
    taxBreakdown: '',
    taxRate: 0,
    totalPrice: 0,
    buyAsAGift: false
  },
  loading: true,
  error: '',
  couponDetails: {
    couponCode: '',
    showMessage: false,
    message: '',
    messageType: _Input.MESSAGE_TYPE_SUCCESS,
    translationKey: ''
  },
  isCouponLoading: false,
  isUpdateLoading: false
};
const fetchCreateOrder = exports.fetchCreateOrder = (0, _toolkit.createAsyncThunk)('order/createOrder', async (offerId, _ref) => {
  let {
    rejectWithValue
  } = _ref;
  try {
    const {
      order
    } = await (0, _api.createOrder)(offerId);
    return order;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const fetchUpdateOrder = exports.fetchUpdateOrder = (0, _toolkit.createAsyncThunk)('order/updateOrder', async (_ref2, _ref3) => {
  let {
    id,
    payload
  } = _ref2;
  let {
    rejectWithValue
  } = _ref3;
  try {
    const {
      order
    } = await (0, _api.updateOrder)(id, payload);
    return order;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const fetchUpdateCoupon = exports.fetchUpdateCoupon = (0, _toolkit.createAsyncThunk)('order/updateCoupon', async (_ref4, _ref5) => {
  let {
    id,
    couponCode
  } = _ref4;
  let {
    rejectWithValue
  } = _ref5;
  try {
    const {
      order
    } = await (0, _api.updateOrder)(id, {
      couponCode
    });
    return order;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const fetchGetOrder = exports.fetchGetOrder = (0, _toolkit.createAsyncThunk)('order/getOrder', async (id, _ref6) => {
  let {
    rejectWithValue
  } = _ref6;
  try {
    const {
      order
    } = await (0, _api.getOrder)(id);
    return order;
  } catch (err) {
    const typedError = err;
    return rejectWithValue(typedError.message);
  }
});
const orderSlice = exports.orderSlice = (0, _toolkit.createSlice)({
  name: 'order',
  initialState,
  reducers: {
    clearOrder: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchCreateOrder.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchCreateOrder.fulfilled, (state, action) => {
      state.loading = false;
      state.order = action.payload;
    });
    builder.addCase(fetchCreateOrder.rejected, (state, _ref7) => {
      let {
        payload
      } = _ref7;
      state.loading = false;
      if (payload) {
        state.error = payload;
      }
    });
    builder.addCase(fetchGetOrder.pending, state => {
      state.loading = true;
    });
    builder.addCase(fetchGetOrder.fulfilled, (state, action) => {
      state.loading = false;
      state.order = action.payload;
    });
    builder.addCase(fetchGetOrder.rejected, state => {
      state.loading = true;
    });
    builder.addCase(fetchUpdateCoupon.pending, (state, action) => {
      state.isCouponLoading = true;
      const {
        couponCode
      } = action.meta.arg;
      state.couponDetails = {
        couponCode: couponCode || '',
        showMessage: false,
        message: '',
        messageType: _Input.MESSAGE_TYPE_SUCCESS,
        translationKey: ''
      };
    });
    builder.addCase(fetchUpdateCoupon.fulfilled, (state, action) => {
      state.isCouponLoading = false;
      state.order = action.payload;
      const {
        couponCode
      } = action.meta.arg;
      state.couponDetails = {
        couponCode: couponCode || '',
        showMessage: true,
        message: 'Your coupon has been applied!',
        messageType: _Input.MESSAGE_TYPE_SUCCESS,
        translationKey: 'coupon-input.success'
      };
    });
    builder.addCase(fetchUpdateCoupon.rejected, (state, action) => {
      state.isCouponLoading = false;
      const {
        couponCode
      } = action.meta.arg;
      state.couponDetails = {
        couponCode: couponCode || '',
        showMessage: true,
        message: 'This is not a valid coupon code for this offer. Please check the code on your coupon and try again.',
        messageType: _Input.MESSAGE_TYPE_FAIL,
        translationKey: 'coupon-input.error'
      };
    });
    builder.addCase(fetchUpdateOrder.pending, state => {
      state.isUpdateLoading = true;
    });
    builder.addCase(fetchUpdateOrder.fulfilled, (state, action) => {
      state.isUpdateLoading = false;
      state.order = action.payload;
    });
    builder.addCase(fetchUpdateOrder.rejected, (state, _ref8) => {
      let {
        payload
      } = _ref8;
      state.isUpdateLoading = false;
      if (payload) {
        state.error = payload;
      }
    });
  }
});
const {
  clearOrder
} = orderSlice.actions;
exports.clearOrder = clearOrder;
const selectOrder = state => state.order;
exports.selectOrder = selectOrder;
const selectOnlyOrder = state => state.order.order;
exports.selectOnlyOrder = selectOnlyOrder;
var _default = exports.default = orderSlice.reducer;